import {useState} from 'react';

export const useModal = () => {
    const [isDisplayed, setDisplay] = useState(false);

    return {
        showModal: () => setDisplay(true),
        hideModal: () => setDisplay(false),
        isDisplayed,
    };
};
